import {
  FaCogs,
  FaServer,
  FaFileCode,
  FaCode,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-apachehttp.png";

export const APACHE_CONSTANTS = {
  HERO: {
    title: "OneMind Services — Apache HTTP Server (One-Click Application) ",
    desc: "Deploy the world’s most widely-used web server, trusted for its performance, flexibility, and robust community support.",
    button: {
      label: "Deploy Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "Apache HTTP Server is a free and open-source cross-platform web server developed by the Apache Software Foundation. It is renowned for its flexibility, reliability, and extensive feature set, making it one of the most popular web servers globally. Apache supports a modular architecture, allowing administrators to extend its functionality through various modules.",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure Apache HTTP Server instance in minutes—no need to install or manage dependencies. ",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes Apache HTTP Server, default configurations, and optimized system settings.",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "root",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    installation: {
      heading: "Installation Location -",
      text: "The main configuration file is located in the directory ",
      location: "/etc/httpd/conf/httpd.conf ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses: ",
      list: ["80 (HTTP)", "443 (HTTPS)"],
    },
    note: "Note: Find the configuration file at /etc/httpd/conf/httpd.conf for customized tweaks or backup.",
  },
  FEATURES: {
    items: [
      {
        icon: FaCogs,
        title: "Modular Architecture",
        text: "Apache's modular design allows administrators to load only the necessary modules, optimizing performance and security.",
      },
      {
        icon: FaServer,
        title: "Virtual Hosting",
        text: "Supports both IP-based and name-based virtual hosting, enabling the hosting of multiple websites on a single server.",
      },
      {
        icon: FaFileCode,
        title: ".htaccess Support",
        text: "Allows directory-level configuration through .htaccess files, providing flexibility in managing server settings.",
      },
      {
        icon: FaCode,
        title: "Extensive Language Support",
        text: "Compatible with various programming languages through modules like mod_php, mod_python, and mod_perl.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or integrate standard backup procedures for Apache configurations and data.",
      },
      {
        label: "Security Out of the Box",
        text: "Hardened with firewall rules, TLS ready, and access control configurations.",
      },
      {
        label: "Scalable Architecture",
        text: "Scale compute, memory, and storage; optionally integrate with load balancers for high availability.",
      },
    ],
  },
  SUPPORT: {
    docsText: "Apache Official Docs ",
    docsLink: "https://httpd.apache.org/docs/",
  },
};
